_postHiddenContent